import src from "IMAGE";
export default { src, width: 370, height: 101, blurWidth: 0, blurHeight: 0};
